import PageLayout from '../../components/page-layout';
import CampaignFrequencyCapCard from './components/CampaignFrequencyCapCard';
import CampaignList from './components/CampaignList';

export default function CampaignManagementPage() {
    return (
        <PageLayout>
            <CampaignFrequencyCapCard />
            <CampaignList />
        </PageLayout>
    );
}
